import { Component, Renderer2, signal,ViewChild  } from '@angular/core';
import { SharedDataService } from '../../Services/SharedServices/shared-data.service';
import { PdfService } from '../../Services/pdfServices/pdf.service';
import { NemaService } from '../../Services/nema.service';
import { CadService } from '../../Services/CADServices/cad.service';
import { IpService } from '../../Services/CADServices/ip.service';
import { environment } from '../../..//Environment/environment';
import { v4 as uuidv4 } from 'uuid';  
import { catchError, map, Observable, of, switchMap, timer } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ModalServiceService } from '../../Services/ModalService/modal-service.service';
import { RegistrationFormComponent } from '../registration-form/registration-form.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserRegisterService } from '../../Services/Registration/user-register.service';
import { SharedUserRegisterService } from '../../Services/Registration/shared-user-register.service';
import { MessageService } from 'primeng/api';
import { SendMailService } from '../../Services/SendMail/send-mail.service';
import { PrivacyModalComponent } from '../CommonComponent/privacy-modal/privacy-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

declare var bootstrap: any;

@Component({
  selector: 'app-final-page',
  templateUrl: './final-page.component.html',
  styleUrl: './final-page.component.css',
  providers: [MessageService] 
})

export class FinalPageComponent {
  scrollToCommonSecondComponent() {
    const hpSecondComponent = document.querySelector('app-second-selection');
    if (hpSecondComponent) {
      hpSecondComponent.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  scrollToCommonFirstComponent() {
    const firstComponent = document.querySelector('app-first-selection');
    if (firstComponent) {
      firstComponent.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  public userDetails!: FormGroup;
  public requestDetails!: FormGroup;
  private init():void{
    this.userDetails = this.formBuilder.group({
      fName: [null, [Validators.required, Validators.pattern(/^[A-Za-z\s'-]+$/)]],
        lName: [null, [Validators.required, Validators.pattern(/^[A-Za-z\s'-]+$/)]],
        company: [null, [Validators.required, Validators.pattern(/^[A-Za-z0-9\s&.,'-]+$/)]],
        city: [null, [Validators.required, Validators.pattern(/^[A-Za-z\s'-]+$/)]],
        state: [null, [Validators.required, Validators.pattern(/^[A-Za-z\s'-]+$/)]],
        country: ['', [Validators.required, Validators.pattern(/^[A-Za-z\s'-]+$/)]],
        email: [null, [Validators.required, Validators.email]],
        phone: [null, [Validators.required, Validators.pattern(/^(\+?\d{1,4}[-]?)?\d{5,15}$/)]],
        comment: [null],
        quantity: [null,],
        policyCheck: [false, Validators.requiredTrue]
    });
  }

  private validateRequestQuote():void{
    this.requestDetails = this.formBuilder.group({
      requestQuantity:[null, Validators.required],
      requestComments:[null,]
    });
  }
 
  private countryNameToCode: { [key: string]: string } = {
    'united states': 'USA',
    'afghanistan': 'AFG',
    'åland islands': 'ALA',
    'aland islands': 'ALA',
    'albania': 'ALB',
    'algeria': 'DZA',
    'american samoa': 'ASM',
    'andorra': 'AND',
    'angola': 'AGO',
    'anguilla': 'AIA',
    'antarctica': 'ATA',
    'antigua and barbuda': 'ATG',
    'argentina': 'ARG',
    'armenia': 'ARM',
    'aruba': 'ABW',
    'australia': 'AUS',
    'austria': 'AUT',
    'azerbaijan': 'AZE',
    'bahamas': 'BHS',
    'bahrain': 'BHR',
    'bangladesh': 'BGD',
    'barbados': 'BRB',
    'belarus': 'BLR',
    'belgium': 'BEL',
    'belize': 'BLZ',
    'benin': 'BEN',
    'bermuda': 'BMU',
    'bhutan': 'BTN',
    'bolivia, plurinational state of': 'BOL',
    'bolivia': 'BOL',
    'bonaire, sint eustatius and saba': 'BES',
    'bosnia and herzegovina': 'BIH',
    'botswana': 'BWA',
    'bouvet island': 'BVT',
    'brazil': 'BRA',
    'british indian ocean territory': 'IOT',
    'brunei darussalam': 'BRN',
    'brunei': 'BRN',
    'bulgaria': 'BGR',
    'burkina faso': 'BFA',
    'burundi': 'BDI',
    'cambodia': 'KHM',
    'cameroon': 'CMR',
    'canada': 'CAN',
    'cape verde': 'CPV',
    'cayman islands': 'CYM',
    'central african republic': 'CAF',
    'chad': 'TCD',
    'chile': 'CHL',
    'china': 'CHN',
    'christmas island': 'CXR',
    'cocos (keeling) islands': 'CCK',
    'colombia': 'COL',
    'comoros': 'COM',
    'congo': 'COG',
    'congo, the democratic republic of the': 'COD',
    'cook islands': 'COK',
    'costa rica': 'CRI',
    "côte d'ivoire": 'CIV',
    "cote d'ivoire": 'CIV',
    'ivory coast': 'CIV',
    'croatia': 'HRV',
    'cuba': 'CUB',
    'curaçao': 'CUW',
    'curacao': 'CUW',
    'cyprus': 'CYP',
    'czech republic': 'CZE',
    'denmark': 'DNK',
    'djibouti': 'DJI',
    'dominica': 'DMA',
    'dominican republic': 'DOM',
    'ecuador': 'ECU',
    'egypt': 'EGY',
    'el salvador': 'SLV',
    'equatorial guinea': 'GNQ',
    'eritrea': 'ERI',
    'estonia': 'EST',
    'ethiopia': 'ETH',
    'falkland islands (malvinas)': 'FLK',
    'falkland islands': 'FLK',
    'faroe islands': 'FRO',
    'fiji': 'FJI',
    'finland': 'FIN',
    'france': 'FRA',
    'french guiana': 'GUF',
    'french polynesia': 'PYF',
    'french southern territories': 'ATF',
    'gabon': 'GAB',
    'gambia': 'GMB',
    'georgia': 'GEO',
    'germany': 'DEU',
    'ghana': 'GHA',
    'gibraltar': 'GIB',
    'greece': 'GRC',
    'greenland': 'GRL',
    'grenada': 'GRD',
    'guadeloupe': 'GLP',
    'guam': 'GUM',
    'guatemala': 'GTM',
    'guernsey': 'GGY',
    'guinea': 'GIN',
    'guinea-bissau': 'GNB',
    'guyana': 'GUY',
    'haiti': 'HTI',
    'heard island and mcdonald islands': 'HMD',
    'holy see (vatican city state)': 'VAT',
    'vatican': 'VAT',
    'honduras': 'HND',
    'hong kong': 'HKG',
    'hungary': 'HUN',
    'iceland': 'ISL',
    'india': 'IND',
    'indonesia': 'IDN',
    'iran, islamic republic of': 'IRN',
    'iran': 'IRN',
    'iraq': 'IRQ',
    'ireland': 'IRL',
    'isle of man': 'IMN',
    'israel': 'ISR',
    'italy': 'ITA',
    'jamaica': 'JAM',
    'japan': 'JPN',
    'jersey': 'JEY',
    'jordan': 'JOR',
    'kazakhstan': 'KAZ',
    'kenya': 'KEN',
    'kiribati': 'KIR',
    "korea, democratic people's republic of": 'PRK',
    'north korea': 'PRK',
    'korea, republic of': 'KOR',
    'south korea': 'KOR',
    'kuwait': 'KWT',
    'kyrgyzstan': 'KGZ',
    "lao people's democratic republic": 'LAO',
    'laos': 'LAO',
    'latvia': 'LVA',
    'lebanon': 'LBN',
    'lesotho': 'LSO',
    'liberia': 'LBR',
    'libya': 'LBY',
    'liechtenstein': 'LIE',
    'lithuania': 'LTU',
    'luxembourg': 'LUX',
    'macao': 'MAC',
    'macau': 'MAC',
    'macedonia, the former yugoslav republic of': 'MKD',
    'macedonia': 'MKD',
    'madagascar': 'MDG',
    'malawi': 'MWI',
    'malaysia': 'MYS',
    'maldives': 'MDV',
    'mali': 'MLI',
    'malta': 'MLT',
    'marshall islands': 'MHL',
    'martinique': 'MTQ',
    'mauritania': 'MRT',
    'mauritius': 'MUS',
    'mayotte': 'MYT',
    'mexico': 'MEX',
    'micronesia, federated states of': 'FSM',
    'micronesia': 'FSM',
    'moldova, republic of': 'MDA',
    'moldova': 'MDA',
    'monaco': 'MCO',
    'mongolia': 'MNG',
    'montenegro': 'MNE',
    'montserrat': 'MSR',
    'morocco': 'MAR',
    'mozambique': 'MOZ',
    'myanmar': 'MMR',
    'burma': 'MMR',
    'namibia': 'NAM',
    'nauru': 'NRU',
    'nepal': 'NPL',
    'netherlands': 'NLD',
    'new caledonia': 'NCL',
    'new zealand': 'NZL',
    'nicaragua': 'NIC',
    'niger': 'NER',
    'nigeria': 'NGA',
    'niue': 'NIU',
    'norfolk island': 'NFK',
    'northern mariana islands': 'MNP',
    'norway': 'NOR',
    'oman': 'OMN',
    'pakistan': 'PAK',
    'palau': 'PLW',
    'palestinian territory, occupied': 'PSE',
    'palestine': 'PSE',
    'panama': 'PAN',
    'papua new guinea': 'PNG',
    'paraguay': 'PRY',
    'peru': 'PER',
    'philippines': 'PHL',
    'pitcairn': 'PCN',
    'poland': 'POL',
    'portugal': 'PRT',
    'puerto rico': 'PRI',
    'qatar': 'QAT',
    'réunion': 'REU',
    'reunion': 'REU',
    'romania': 'ROU',
    'russian federation': 'RUS',
    'russia': 'RUS',
    'rwanda': 'RWA',
    'saint barthélemy': 'BLM',
    'saint barthelemy': 'BLM',
    'saint helena, ascension and tristan da cunha': 'SHN',
    'saint helena': 'SHN',
    'saint kitts and nevis': 'KNA',
    'saint lucia': 'LCA',
    'saint martin (french part)': 'MAF',
    'saint martin': 'MAF',
    'saint pierre and miquelon': 'SPM',
    'saint vincent and the grenadines': 'VCT',
    'samoa': 'WSM',
    'san marino': 'SMR',
    'sao tome and principe': 'STP',
    'saudi arabia': 'SAU',
    'senegal': 'SEN',
    'serbia': 'SRB',
    'seychelles': 'SYC',
    'sierra leone': 'SLE',
    'singapore': 'SGP',
    'sint maarten (dutch part)': 'SXM',
    'sint maarten': 'SXM',
    'slovakia': 'SVK',
    'slovenia': 'SVN',
    'solomon islands': 'SLB',
    'somalia': 'SOM',
    'south africa': 'ZAF',
    'south georgia and the south sandwich islands': 'SGS',
    'south sudan': 'SSD',
    'spain': 'ESP',
    'sri lanka': 'LKA',
    'sudan': 'SDN',
    'suriname': 'SUR',
    'svalbard and jan mayen': 'SJM',
    'swaziland': 'SWZ',
    'sweden': 'SWE',
    'switzerland': 'CHE',
    'syrian arab republic': 'SYR',
    'syria': 'SYR',
    'taiwan, province of china': 'TWN',
    'taiwan': 'TWN',
    'tajikistan': 'TJK',
    'tanzania, united republic of': 'TZA',
    'tanzania': 'TZA',
    'thailand': 'THA',
    'timor-leste': 'TLS',
    'east timor': 'TLS',
    'togo': 'TGO',
    'tokelau': 'TKL',
    'tonga': 'TON',
    'trinidad and tobago': 'TTO',
    'tunisia': 'TUN',
    'turkey': 'TUR',
    'turkmenistan': 'TKM',
    'turks and caicos islands': 'TCA',
    'tuvalu': 'TUV',
    'uganda': 'UGA',
    'ukraine': 'UKR',
    'united arab emirates': 'ARE',
    'uae': 'ARE',
    'united kingdom': 'GBR',
    'uk': 'GBR',
    'united states minor outlying islands': 'UMI',
    'uruguay': 'URY',
    'uzbekistan': 'UZB',
    'vanuatu': 'VUT',
    'venezuela, bolivarian republic of': 'VEN',
    'venezuela': 'VEN',
    'viet nam': 'VNM',
    'vietnam': 'VNM',
    'virgin islands, british': 'VGB',
    'virgin islands, u.s.': 'VIR',
    'wallis and futuna': 'WLF',
    'western sahara': 'ESH',
    'yemen': 'YEM',
    'zambia': 'ZMB',
    'zimbabwe': 'ZWE'
  };
  signalStatus:boolean=false;
  panelOpenState = signal(this.signalStatus);
  seriesSelectedArray: any;
  configurationNumber:any;
  modelNumber:any;
  public HpSpecDataResponse: any = {};
  public formSelectionData: any = {};
  imageAvailable = false;
  basePath: any;
  isImageLoaded: boolean = false;
  imageUrl:any;
  // public finalData:any={};
  DutyCycle:any;
  Size:any;
  Series:any;
  newSize:any;
  inputTypeData:any;
  fileType:any;
  fileRequest:any;
  userLoginStatus:any;
  formSubmitted = false;
  requestFormSubmitted = false;
  buttonsArray = ["Btn_Quote","Btn_Spec"];
  UserDBData:any={};
  firstName:any;
  quantity:any;
  email:any;
  lastName:any;
  company:any;
  city:any;
  state:any;
  country:any;
  mobile:any;
quoteUserData:any={};
cadChangeStatus:any;
AssetbasePath:any;
  constructor(public dialog: MatDialog,private sendmail:SendMailService, private messageService: MessageService,private userSharedService:SharedUserRegisterService, private userRegisterService:UserRegisterService , private formBuilder:FormBuilder,private service:NemaService,private sharedDataService: SharedDataService, private pdfService : PdfService, private cadService: CadService, private ipService:IpService,private http: HttpClient,private renderer: Renderer2, private router: Router, private snackBar: MatSnackBar){
    this.basePath = environment.imgPathUrl;
    this.AssetbasePath = environment.assetsPath;
  }
  showSuccess(summary:any, detail:any) {
    this.messageService.add({
      severity: 'success', 
      summary: summary, 
      detail: detail,
      icon: 'pi pi-check-circle',
      life: 5000});
  }
  showConfirm(firstName:any) {
    const currentUrl = window.location.href.toLowerCase();
    if (currentUrl.includes('spineatools'))
          {
          this.messageService.add({
          key: 'confirm',  // Use the key to target the specific toast
          severity: 'info', // Set the severity level (info, success, etc.)
          icon: 'pi pi-check-circle',          
          summary: "Hi " + firstName + ", your request has been sent to the Spinea sales team.", // Message title
          detail: "Our team will contact you soon. For any questions, please call 888.994.2663.", // Message details
    
          life: 5000  // Duration the toast is visible (optional)
          });
        }
        else
        {
          this.messageService.add({
          key: 'confirm',  // Use the key to target the specific toast
          severity: 'info', // Set the severity level (info, success, etc.)
          icon: 'pi pi-check-circle',          
          summary: "Hi " + firstName + ", your request has been sent to the Cone Drive sales team.", // Message title
          detail: "Our team will contact you soon. For any questions, please call 888.994.2663.", // Message details
    
          life: 5000  // Duration the toast is visible (optional)
          });
        }
  }

  // This method will be called when the "Reply" button inside the toast is clicked
  onConfirm() {
    console.log('Reply button clicked!');
    // You can implement additional logic here, such as navigating to another page, etc.
  }

  // This method will be called when the toast is closed
  onReject() {
    console.log('Toast closed');
    // Handle any cleanup or logic when the toast is dismissed
  }
  RequestQuote(){
    debugger;
    
    this.setFileType("Request Quote","requestQuote");
    if(this.userLoginStatus == true){
      document.cookie = "CookiesCode="+this.configurationNumber;
        const currentUrl = window.location.href.toLowerCase();
      if (currentUrl.includes('spineatools')) {
        this.setAnalytics("HP (PowerMate)(spineatools)", "RequestQuoteClick");
      } else {
        this.setAnalytics("HP (PowerMate)", "RequestQuoteClick");
      }

      // this.generatePdf();
      // alert("Here we will have our Request logic");
  }else{
    const modalElement = document.getElementById('commonRegisterModal');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
  }
  }
  userQuickUpdate(typeofFile:any){
    const userData = {
        FirstName: this.userDetails.get('fName')?.value,
        LastName: this.userDetails.get('lName')?.value,
        email: this.userDetails.get('email')?.value,
        Company: this.userDetails.get('company')?.value,
        City: this.userDetails.get('city')?.value,
        State: this.userDetails.get('state')?.value,
        Country: this.userDetails.get('country')?.value,
        ContactNumber: this.userDetails.get('phone')?.value,
        Quantity:this.requestDetails.get('requestQuantity')?.value,
        Request:this.fileRequest||null,
        Code:this.configurationNumber,
        Comment:this.requestDetails.get('requestComments')?.value

      };
    
    this.userUpdate(JSON.stringify(userData),typeofFile);
  }
  DownloadSpec() {
    debugger;
    this.setFileType("Specification","specification");
    
    if(this.userLoginStatus == true){
      if(this.configurationNumber!=this.sharedDataService.getCookie("CookiesCode")){
        document.cookie = "CookiesCode="+this.configurationNumber;
        const currentUrl = window.location.href.toLowerCase();
        if (currentUrl.includes('spineatools')) {
          this.setAnalytics("HP (PowerMate)(spineatools)","RegisterClick");
        } else {
          this.setAnalytics("HP (PowerMate)","RegisterClick");
        }
      }
        this.generatePdf();
        this.showSuccess("Success","Spec Sheet has been Downloaded");
        this.userQuickUpdate("specification");
        
        // this.dialogRef.close();
    }else{
      const modalElement = document.getElementById('commonRegisterModal');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }      
    }
  }
  showDrawingRegister(){
    this.setFileType("Drawing Download","drawingdownload");
    
    // if(this.userLoginStatus == true){
        
    //     this.generatePdf();
    //     this.showSuccess("Success","Spec Sheet Downloaded");
        
    //     // this.dialogRef.close();
    // }else{
      const intervalId = setInterval(() => {
        const buttonElement = document.getElementById('Btn_DrawingDownload');
        if (buttonElement) {
          buttonElement.setAttribute('data-bs-toggle', 'modal');
          buttonElement.setAttribute('data-bs-target', '#commonRegisterModal');
          clearInterval(intervalId);
        }
      }, 1000);
      
    // }
  }
  download3DPDFWithStatus(){
    if(this.configurationNumber!=this.sharedDataService.getCookie("CookiesCode")){
        document.cookie = "CookiesCode="+this.configurationNumber;
        const currentUrl = window.location.href.toLowerCase();
        if (currentUrl.includes('spineatools')) {
          this.setAnalytics("HP (PowerMate)(spineatools)","RegisterClick");
        } else {
          this.setAnalytics("HP (PowerMate)","RegisterClick");
        }
      }
    this.setFileType("Drawing Downloads","drawingDownload");
    this.download3DPDF();
    this.showSuccess("Success","3d PDF has been Downloaded");
    this.userQuickUpdate("drawingDownload");
  }
  download3DFileWithStatus(){
    if(this.configurationNumber!=this.sharedDataService.getCookie("CookiesCode")){
        document.cookie = "CookiesCode="+this.configurationNumber;
        const currentUrl = window.location.href.toLowerCase();
        if (currentUrl.includes('spineatools')) {
          this.setAnalytics("HP (PowerMate)(spineatools)","RegisterClick");
        } else {
          this.setAnalytics("HP (PowerMate)","RegisterClick");
        }
      }
    this.setFileType("Drawing Downloads","drawingDownload");
    this.download3DFile();
    this.showSuccess("Success","3d File has been Downloaded");
    this.userQuickUpdate("drawingDownload");
  }
  download2DFileWithStatus(){
    if(this.configurationNumber!=this.sharedDataService.getCookie("CookiesCode")){
        document.cookie = "CookiesCode="+this.configurationNumber;
        const currentUrl = window.location.href.toLowerCase();
        if (currentUrl.includes('spineatools')) {
          this.setAnalytics("HP (PowerMate)(spineatools)","RegisterClick");
        } else {
          this.setAnalytics("HP (PowerMate)","RegisterClick");
        }
      }
    this.setFileType("Drawing Downloads","drawingDownload");
    this.download2DFile();
    this.showSuccess("Success","2d File has been Downloaded");
    this.userQuickUpdate("drawingDownload");
  }
  funRemove(){
    const intervalId = setInterval(() => {
      let buttonsArray: string[] = ["Btn_Quote","Btn_Spec","Btn_DrawingDownload"];
      if (buttonsArray.length > 0) {
        buttonsArray.forEach(btnData => {
          const buttonElement = document.getElementById(btnData);
          if (buttonElement) {
            buttonElement.removeAttribute('data-bs-toggle');
            buttonElement.removeAttribute('data-bs-target');
            clearInterval(intervalId);
          }
        });}
    }, 1000);
  }
  funGet(){
    const intervalId = setInterval(() => {
      let buttonsArray: string[] = ["Btn_Quote","Btn_Spec","Btn_DrawingDownload"];
      if (buttonsArray.length > 0) {
        buttonsArray.forEach(btnData => {
          const buttonElement = document.getElementById(btnData);
          if (buttonElement) {
            buttonElement.setAttribute('data-bs-toggle', 'modal');
            buttonElement.setAttribute('data-bs-target', '#commonRegisterModal');
            clearInterval(intervalId);
          }
        });}
    }, 1000);
  }
  assignRequestQuote(){
    const intervalId = setInterval(() => {
      let buttonsArray: string[] = ["Btn_Quote"];
      if (buttonsArray.length > 0) {
        buttonsArray.forEach(btnData => {
          const buttonElement = document.getElementById(btnData);
          if (buttonElement) {
            buttonElement.setAttribute('data-bs-toggle', 'modal');
            buttonElement.setAttribute('data-bs-target', '#sendQuoteModal');
            clearInterval(intervalId);
          }
        });}
    }, 1000);
  }
  setFileType(fileName:any,filetype:any){
    this.fileType = filetype;
    this.fileRequest = fileName;
  }
  processQuoteSubmit(){
    debugger;
    this.requestFormSubmitted = true;
    if (this.requestDetails.valid) {
      const userData = {
        FirstName: this.userDetails.get('fName')?.value,
        LastName: this.userDetails.get('lName')?.value,
        email: this.userDetails.get('email')?.value,
        Company: this.userDetails.get('company')?.value,
        City: this.userDetails.get('city')?.value,
        State: this.userDetails.get('state')?.value,
        Country: this.userDetails.get('country')?.value,
        ContactNumber: this.userDetails.get('phone')?.value,
        Quantity:this.requestDetails.get('requestQuantity')?.value,
        Request:this.fileRequest||null,
        Code:this.configurationNumber,
        Comment:this.requestDetails.get('requestComments')?.value

      };
      this.quoteUserData={
        quantity:userData.Quantity,
        email:userData.email,
        firstName:userData.FirstName,
        lastName:userData.LastName,
        company:userData.Company,
        city:userData.City,
        state:userData.State,
        country:userData.Country,
        mobile:userData.ContactNumber,
        comment:userData.Comment
      };
      
      this.userUpdate(JSON.stringify(userData),"requestQuote");
      const currentUrl = window.location.href.toLowerCase();
      if (currentUrl.includes('spineatools')) {
        this.setAnalytics("HP (PowerMate)(spineatools)", "RequestQuoteClick");
      } else {
        this.setAnalytics("HP (PowerMate)", "RequestQuoteClick");
      }
    }else{
      // console.log("All the data is not filled yet");
    }
  }
  processSubmit(){
    debugger;
    this.formSubmitted = true;
    if (this.userDetails.valid) {
      const userData = {
        FirstName: this.userDetails.get('fName')?.value,
        LastName: this.userDetails.get('lName')?.value,
        email: this.userDetails.get('email')?.value,
        Company: this.userDetails.get('company')?.value,
        City: this.userDetails.get('city')?.value,
        State: this.userDetails.get('state')?.value,
        Country: this.userDetails.get('country')?.value,
        ContactNumber: this.userDetails.get('phone')?.value,
        Quantity:this.userDetails.get('quantity')?.value||null,
        Comment:this.userDetails.get('comment')?.value||null,
        Request:this.fileRequest||null,
        Code:this.configurationNumber
      };
      this.firstName = userData.FirstName
      this.quoteUserData={
        quantity:userData.Quantity,
        email:userData.email,
        firstName:userData.FirstName,
        lastName:userData.LastName,
        company:userData.Company,
        city:userData.City,
        state:userData.State,
        country:userData.Country,
        mobile:userData.ContactNumber,
        comment:userData.Comment
      };
      this.userRegister(JSON.stringify(userData));
      if(this.userDetails.valid){
          $('#closeRegisterModal').click();
        }
    }else{
    }
  }
  
  public userRegister(reducer: any):void{
    this.userRegisterService.userRegister(reducer).subscribe(result=>{
      if(result.body==true){
        this.funRemove();
        this.assignRequestQuote();
        this.userLoginStatus = true;
        this.getUserRegister("");
        if(this.fileType=="specification"){
          document.cookie = "CookiesCode="+this.configurationNumber;
          const currentUrl = window.location.href.toLowerCase();
          if (currentUrl.includes('spineatools')) {
            this.setAnalytics("HP (PowerMate)(spineatools)","RegisterClick");
          } else {
          this.setAnalytics("HP (PowerMate)","RegisterClick");}
          this.generatePdf();
          this.showSuccess("Success","Spec Sheet Downloaded");
        }
        if(this.fileType=="requestQuote"){
          document.cookie = "CookiesCode="+this.configurationNumber;
          const currentUrl = window.location.href.toLowerCase();
          if (currentUrl.includes('spineatools')) {
            this.setAnalytics("HP (PowerMate)(spineatools)", "RequestQuoteClick");
          } else {
            this.setAnalytics("HP (PowerMate)", "RequestQuoteClick");
          }
          this.showConfirm(this.firstName);
          this.processAndSendPDF();
        }
      }
    });
  }

  userProfiles: any[] = [];
  showEmailSearch: boolean = false;
  searchEmail: string = '';
  public getUserRegister(reducer: any):void{
    this.userRegisterService.getuserRegister(reducer).subscribe({
      next: (result) => {

        if (result != null && result.length > 0) {
          if (result.length > 1) {
            // Multiple profiles found - prompt for email search
            this.userProfiles = result;
            this.showEmailSearch = true;
            //this.showProfileSelection = false;
            console.log('Multiple profiles found:', result.length, '- prompting for email search');
            console.log('User profiles:', JSON.stringify(result, null, 2));
          } else if (result.length === 1) {
            // Single profile - auto-populate form
            console.log('User data before populate:', JSON.stringify(result[0], null, 2));
            this.populateForm(result[0]);
            console.log('Single profile found - auto-populated');
          }
        }
        else {
          // No existing profile found - user can enter new details
          console.log('No existing profile found for this IP');
        }
      }
    });
  }
  public userUpdate(reducer: any,typeofFile:any):void{
    this.userRegisterService.userUpdate(reducer).subscribe(result=>{
      if(result!=null){
        this.userLoginStatus = true;
        this.funRemove();
        this.assignRequestQuote();
        if(typeofFile=="requestQuote"){
          this.showConfirm(this.UserDBData.firstName);
          this.processAndSendPDF();
        }
        // this.userSharedService.setUserInformation(result);
      }else{
        this.funGet();
      }
    });
  }

  UserDBInformation(){
    debugger;
    this.userSharedService.userDetails$.subscribe((userData:any) => 
      {
        this.UserDBData= userData;
        console.log("I am user Registered Data");
        console.log(this.UserDBData);
      });
  }



  dutyCycle:any;
  inputPower:any;
Units:any;
Speed:any;
Ratio:any;
ServiceFactor:any;
OutputSpeed:any;
  public showspinfo: boolean = false;
  public showcdinfo: boolean = false;

  ngOnInit():void{
    const currentUrl = window.location.href.toLowerCase();
  if (currentUrl.includes('spineatools') ) {
      this.showspinfo = true;
      this.showcdinfo = false;
    } else {
      this.showspinfo = false;
      this.showcdinfo = true;
    }
    this.init();
    this.validateRequestQuote();
    this.getUserRegister("");
    this.sharedDataService.getFormData().subscribe(data => {
      this.dutyCycle = data.selectedDutyCycle; 
      this.inputPower = data.selectedInputPower;
      this.Units = data.selectedUnits;
      this.Speed = data.selectedSpeed;
      this.Ratio = data.selectedRatio;
      this.ServiceFactor = data.selectedServiceFactor;
      this.OutputSpeed = data.selectedOutputSpeed;
    });
    this.sharedDataService.cadChange$.subscribe((data:any) => 
      {
        console.log("HP CAD status", data);
        if(data=="true"){
          const cadGenArea:any = document.getElementById('cadGenerateArea');
          const cadProArea:any = document.getElementById('cadProcessArea');
          const cadShArea:any = document.getElementById('cadShownArea');
          if (cadGenArea) {
            // Check if the div is currently visible
            if (cadGenArea.style.display === 'none') {
              // Show the div
              cadGenArea.style.display = 'block';
              cadProArea.style.display = 'none';
              cadShArea.style.display = 'none';
            } 
          }
        }
          
      });
    this.sharedDataService.getSeriesData().subscribe(data => {
      
      this.Series = data;
      console.log("MY SERIES IS FROM HP-Step 1", data);
      
    });
    this.userSharedService.userDetails$.subscribe((userData:any) => 
      {
        this.UserDBData= userData;
      });
  //   this.sharedDataService.series$.subscribe(series => {
  //     console.log("MY SERIES IS FROM HP step -2", series);
  //     this.Series = series;
  // });
  // this.sharedDataService.getFormData().subscribe(data => {
    
  //   this.formSelectionData={
  //     SelectedInputPower:data.selectedInputPower || "Null",
  //     SelectedUnits:data.selectedUnits || "Null",
  //     SelectedSpeed:data.selectedSpeed || "Null",
  //     SelectedRatio:data.selectedRatio || "Null",
  //     SelectedDutyCycle:data.selectedDutyCycle || "Null",
  //     SelectedServiceFactor:data.selectedServiceFactor || "Null",
  //     SelectedOutputSpeed:data.selectedOutputSpeed || "Null"
  //   };
  //   console.log("Series HP Form Selection Data is here:- ",this.formSelectionData);
  // });
    this.sharedDataService.formData$.subscribe((formData) => {
      debugger;
      this.formSelectionData={
        SelectedInputPower:formData.selectedInputPower || "Null",
        SelectedUnits:formData.selectedUnits || "Null",
        SelectedSpeed:formData.selectedSpeed || "Null",
        SelectedRatio:formData.selectedRatio || "Null",
        SelectedDutyCycle:formData.selectedDutyCycle || "Null",
        SelectedServiceFactor:formData.selectedServiceFactor || "Null",
        SelectedOutputSpeed:formData.selectedOutputSpeed || "Null"
        
      };
      console.log("Series HP Form Selection Data is here:- ",this.formSelectionData);
      this.DutyCycle = formData.selectedDutyCycle
      this.seriesSelectedArray = formData;
      console.log(JSON.stringify(formData, null, 2));
       });
    
    this.sharedDataService.specData$.subscribe((specData:any) => 
    {
      this.HpSpecDataResponse={
        size:specData.size,
        ratio:specData.ratio,
        speed:specData.speed,
    IppowerMechImp:specData.IppowerMechImp,
    IppowerMechMet:specData.IppowerMechMet,
    IptorqueImp:specData.IptorqueImp,
    IptorqueMet:specData.IptorqueMet,
    IptorqueAccellImp:specData.IptorqueAccellImp,
    IptorqueAccellMet:specData.IptorqueAccellMet,
    IppowerthermalImp:specData.IppowerthermalImp,
    IppowerthermalMet:specData.IppowerthermalMet,
    IppowerFanThermalImp:specData.IppowerFanThermalImp,
    IppowerFanThermalMet:specData.IppowerFanThermalMet,
    OptorqueImp:specData.OptorqueImp,
    OptorqueMet:specData.OptorqueMet,
    OptorqueAccellImp:specData.OptorqueAccellImp,
    OptorqueAccellMet:specData.OptorqueAccellMet,
    EfficiencyImp:specData.EfficiencyImp,
    EfficiencyMet:specData.EfficiencyMet
      };
    });
  
    this.sharedDataService.SizeData$.subscribe((SizeData:any) => 
    {
      this.Size = SizeData
      console.log("Size from step 2 in step 3"+JSON.stringify(SizeData, null, 2));
    });



    this.sharedDataService.configurationNumberData$.subscribe((result:any) => 
    {
      this.signalStatus=true;
      this.panelOpenState = signal(this.signalStatus);
    
      console.log("This below is my data");
      console.log(result);
      console.log("SERIESSERIES:", result.series);
      this.inputTypeData = result.inputType;
      this.finalData.InputTypeDesc=result.InputTypeDesc;
      this.finalData.OutputTypeDesc=result.OutputTypeDesc;
      var Size=result.Size;
      var Inputspeed = result.inputSpeed;
      const sizeLength=result.Size.length;
      if(sizeLength == 2){
        Size = "-"+result.Size
      }
      if(result.InputSpeed=="100"){
        Inputspeed="A";
      }else if(result.InputSpeed=="580"){
        Inputspeed="B";
      }else if(result.InputSpeed=="720"){
        Inputspeed="C";
      }else if(result.InputSpeed=="870"){
        Inputspeed="D";
      }else if(result.InputSpeed=="1150"){
        Inputspeed="E";
      }else if(result.InputSpeed=="1450"){
        Inputspeed="F";
      }else if(result.InputSpeed=="1750"){
        Inputspeed="G";
      }


      
      
      //if solid - else below logic
      if(result.ShaftType=="HollowOutputBore"){
      
      if(result.Size =="20"){
        switch(result.BoreDia){
          case "1":
            result.ShaftCode="A";
            break;
          case "1.125":
            result.ShaftCode="B";
            break;
          case "1.1875":
            result.ShaftCode="C";
            break;
          case "1.250":
            result.ShaftCode="D";
            break;
          case "1.375":
            result.ShaftCode="E";
            break;
        }
      } else if(result.Size =="25"){
        switch(result.BoreDia){
          case "1.1875":
            result.ShaftCode="C";
            break;
          case "1.250":
            result.ShaftCode="D";
            break;
          case "1.25":
            result.ShaftCode="D";
            break;
          case "1.4375":
            result.ShaftCode="F";
            break;
          case "1.6875":
            result.ShaftCode="H";
            break;
          case "1.9375":
            result.ShaftCode="J";
            break;
          case "2":
            result.ShaftCode="K";
            break;
        } 
      }else if(result.Size=="30"){
        switch(result.BoreDia){
          case "1.5":
            result.ShaftCode="G";
            break;
          case "1.6875":
            result.ShaftCode="H";
            break;
          case "1.9375":
            result.ShaftCode="J";
            break;
          case "2.1875":
            result.ShaftCode="L";
            break;
          case "2.4375":
            result.ShaftCode="M";
            break;
          case "2.5":
            result.ShaftCode="N";
            break;
        } 
      }else if(result.Size=="35"){
        switch(result.BoreDia){
          case "1.6875":
            result.ShaftCode="H";
            break;
          case "1.9375":
            result.ShaftCode="J";
            break;
          case "2.1875":
            result.ShaftCode="L";
            break;
          case "2.4375":
            result.ShaftCode="M";
            break;
          case "2.5":
            result.ShaftCode="N";
            break;
          case "2.6875":
            result.ShaftCode="P";
            break;
          case "2.75":
            result.ShaftCode="Q";
            break;
        } 
      }else if(result.Size=="40"){
        switch(result.BoreDia){
          case "2.1875":
            result.ShaftCode="L";
            break;
          case "2.4375":
            result.ShaftCode="M";
            break;
          case "2.6875":
            result.ShaftCode="P";
            break;
          case "2.9375":
            result.ShaftCode="R";
            break;
        } 
      }else if(result.Size=="50"){
        switch(result.BoreDia){
          case "2.75":
            result.ShaftCode="Q";
            break;
          case "3.1875":
            result.ShaftCode="S";
            break;
          case "3.4375":
            result.ShaftCode="T";
            break;
        } 
      }else if(result.Size=="60"){
        switch(result.BoreDia){
          case "2.9375":
            result.ShaftCode="R";
            break;
          case "3.4375":
            result.ShaftCode="T";
            break;
          case "3.9375":
            result.ShaftCode="U";
            break;
        } 
      }else if((result.Size=="70")||(Size=="80")){
        switch(result.BoreDia){
          case "3.9375":
            result.ShaftCode="U";
            break;
          case "4.4375":
            result.ShaftCode="V";
            break;
        } 
      }else if(result.Size=="100"){
        switch(result.BoreDia){
          case "5.9375":
            result.ShaftCode="W";
            break;
        } 
      }else if(result.Size=="120"){
        switch(result.BoreDia){
          case "7.9375":
            result.ShaftCode="X";
            break;
        } 
      }
    }else{
      result.ShaftCode="-";
    }

;

var MountPosition = result.MountingPosition;
// getMountPosition(){

// }
debugger;
var coolType=result.coolingType;
var Fan="";
if(this.Series=="HP"){
  result.coolingType = "";
}
    if(result.coolingType!=""){
      if(result.coolingType=="Fan on input shaft"){
        Fan="A";
      }else if(result.coolingType=="Fan opposite input on double extended shaft"){
        Fan="B";
      }else if(result.coolingType=="Fan opposite input, no extension"){
        Fan="C";
      }else {
        Fan="N";
      }
      debugger;
      switch(result.GearOrientation){
        
        case "HO":
        case "HU":
          switch(result.inputType){
            case "SE":
            case "SA":
              if((Fan=="C")||(Fan=="B")){
                switch(result.MountingPosition.substring(1,2)){
                  case "1":
                    MountPosition=(result.MountingPosition).toString().replace("1","4");
                    break;
                  case "2":
                    MountPosition=(result.MountingPosition).toString().replace("2","5");
                    break;
                  case "3":
                    MountPosition=(result.MountingPosition).toString().replace("3","6");
                    break;
                  default:
                    break;
                }
              }else{
                MountPosition = result.MountingPosition;
              }
              break;
            default:
              MountPosition= result.MountingPosition;
              break;
          }
          break;
        

        case "HV":
          switch(result.inputType){
            case "SE":
            case "SA":
              if((Fan=="C")||(Fan=="B")){
                switch(result.MountingPosition.substring(1,2)){
                  case "7":
                    MountPosition=(result.MountingPosition).toString().replace("7","9");
                    break;
                  case "8":
                    MountPosition=(result.MountingPosition).toString().replace("8","0");
                    break;
                  
                  default:
                    MountPosition = result.MountingPosition;
                    break;
                }
              }else{
                MountPosition = result.MountingPosition;
              }
              break;
            
          }
        break;
        default:
          MountPosition=result.MountingPosition;
          break;
      }
    }else{
      Fan="N";
    }
    // var mountingPosition=result.MountingPosition
    var mountingPosition=MountPosition
    if(mountingPosition.substring(0,1)=="-" && mountingPosition.substring(2, 3) == "-" ){
      mountingPosition = mountingPosition.substring(2, 1)
    }
    else if(mountingPosition.substring(0, 1) == "-"){
      mountingPosition = mountingPosition.substring(1,3)
    }
    else if(mountingPosition.substring(2, 3) == "-"){
      mountingPosition = mountingPosition.substring(0, 2)
    }
    else if(mountingPosition.substring(2) == "-"){
      mountingPosition = mountingPosition.substring(0, 2)
    }
    // var size = result.Size
    if(Size.substring(0,1)=="0" || Size.substring(0,1)=="-"){
      Size = Size.substring(1)
    }
    if(sizeLength == 2){
      this.newSize = "-"+result.Size
    }
    if(this.Series=="HP" || this.formSelectionData.SelectedDutyCycle=="no"){
      Fan="N";
    }
      this.configurationNumber = result.GearOrientation+this.newSize+MountPosition+result.ShaftCode+result.MotorAdaptor+Fan+Inputspeed+"0"+result.Ratio;
      
      if(Size.substring(0,1)=="-"){
        Size = Size.substring(1);
      }
      
      console.log("THis is my configno" + this.configurationNumber);
      
      
      
      
      
      
      
      
      
      var motorAdaptor = result.MotorAdaptor
        if((motorAdaptor == "N")||motorAdaptor == ""){
          motorAdaptor = ""
          // result.MotorAdaptor = "N"
        }
        else{
          motorAdaptor = "M"
        }
     
      
        var BoreDiameter=result.BoreDia;
        if(result.BoreDia != ""){
          BoreDiameter = "S"
        }else{
          BoreDiameter = ""
        }

debugger;
    var modelFan = "";
    var newFanCode="";
    if(this.DutyCycle!='yes' && this.Series!='HPNOFAN'){
      // newFanCode="";
      // modelFan = "";
      result.coolingType="";
    }
    if(result.coolingType!=""){
        if(result.coolingType=="Fan on input shaft"){
          newFanCode="A046";
        }else if(result.coolingType=="Fan opposite input on double extended shaft"){
          newFanCode="A047";
        }else if(result.coolingType=="Fan opposite input, no extension"){
          newFanCode="A048";
        }
          modelFan="F";
        }
        else{
        modelFan="";
      }
      if(modelFan=="F"){
        if(Inputspeed == "A" || Inputspeed == "B" || Inputspeed == "C" || Inputspeed == "D" || Inputspeed == "E" || Inputspeed == "F" || Inputspeed == "G"){
          if(Inputspeed == "E" || Inputspeed == "F" || Inputspeed == "G"){
            this.modelNumber = modelFan + motorAdaptor + BoreDiameter + result.GearOrientation + Size + newFanCode + "-" + mountingPosition
          }else{
            this.modelNumber = "Special model number to be determined"
          }
        }else{
          this.modelNumber = modelFan + motorAdaptor + BoreDiameter + result.GearOrientation + Size + newFanCode + "-" + mountingPosition
        }
      }
      else{
       
        if(Inputspeed == "A" || Inputspeed == "B" || Inputspeed == "C" || Inputspeed == "D" || Inputspeed == "E" || Inputspeed == "F" || Inputspeed == "G"){
          if(Inputspeed == "E" || Inputspeed == "F" || Inputspeed == "G"){
            this.modelNumber = motorAdaptor + BoreDiameter + result.GearOrientation + Size + "-" + mountingPosition
          }else{
            this.modelNumber = motorAdaptor + BoreDiameter + result.GearOrientation + Size + "A068" + "-" + mountingPosition
          }
        }else{
          this.modelNumber = motorAdaptor + BoreDiameter + result.GearOrientation + Size + "-" + mountingPosition
        }

      }






        
      this.finalData.ModelNo=this.modelNumber;
      this.finalData.ConfigurationNo=this.configurationNumber;
      this.finalData.Ratio =result.Ratio;
      this.finalData.Speed=result.InputSpeed;
      this.finalData.Size = (parseInt(result.Size)/10).toString() +" inch";
      if(result.GearOrientation=="HU"){
        this.finalData.GearOrientation="Worm Under Gear";
      }else if(result.GearOrientation=="HO"){
        this.finalData.GearOrientation = "Worm Over Gear"
      }else{
        this.finalData.GearOrientation = "Gear Shaft Vertical"
      }
      
      this.finalData.OutputType="";
     
      this.finalData.OutputBoreDia=result.BoreDia;
      this.finalData.AssemblyMountPos=result.MountingPosition;
      this.finalData.AssemblyMountPosText=result.MountingPositionText;
      this.finalData.InputType="";
        var motorAd = result.MotorAdaptor;
      if(result.MotorAdaptor=="A"){
        motorAd = "48C";
      }else if(result.MotorAdaptor == "B"){
        motorAd = "56C";
      }else if(result.MotorAdaptor == "C"){
        motorAd = "143TC/145TC";
      }else if(result.MotorAdaptor == "D"){
        motorAd = "182TC/184TC";
      }else if(result.MotorAdaptor == "E"){
        motorAd = "213TC/215TC";
      }else if(result.MotorAdaptor == "F"){
        motorAd = "254TC/256TC";
      }else{
        motorAd = "None Selected";
      }
      this.finalData.NEMAMotorFrame=motorAd;
      this.finalData.CoolingType="";
      // this.finalData.CoolingType=result.coolingType;
      debugger;
      if(coolType=="N"){
        this.finalData.CoolingTypePass="None";
      } else if(coolType==""){
        this.finalData.CoolingTypePass="None";
      }
      else{
        this.finalData.CoolingTypePass = coolType;
      }
      console.log(this.finalData);
      console.log(this.DutyCycle);
      this.createCAD1();
      
    });
    debugger;
    // if(this.finalData.CoolingType==""){
    //   this.finalData.CoolingTypePass="None";
    // }else{
    //   this.finalData.CoolingTypePass = this.finalData.CoolingType;
    // }

    // this.createCAD1();
  
  }
  
  
  finalData = {
    ModelNo: "",
    ConfigurationNo: "",
    NumberOfReduction: "Single",
    Ratio: "",
    Speed:"",
    Size:"",
    GearOrientation:"",
    OutputType:"",
    OutputBoreDia:"",
    AssemblyMountPos:"",
    InputType:"",
    NEMAMotorFrame:"",
    CoolingType:"",
    InputTypeDesc:"",
    OutputTypeDesc:"",
    AssemblyMountPosText:"",
    CoolingTypePass:"",
    ClientIP:"",
    FlangType:"",
    cadLocation:"",
    cadStatus:"",
    cadImageLocation:""
  };

CADfileFormat={
  CAD2DFileFormat:'.dxf',
  CAD3DFileFormat:'.stp',
};
getMountingPosition(){

}
getShaft(size:any,bore:any){
  var res;
  
}
 

generatePdf() {
  var companyName = ""; 	
var companyAddress; 	
var contactInfo ;	
var website; 		
var tableId; 		
var userInputTable;	
var tableId2;		
var productCode; 	
var productName; 	

  const currentUrl = window.location.href.toLowerCase();
    if (currentUrl.includes('spineatools')) {

     companyName = "SPINEA";
     companyAddress="s.r.o., Ku Magašu 702/3, 080 01 Haniska, District of Prešov, Slovakia";
     contactInfo = "Tel: +421 51 77 00 155, Sales: +421 51 77 00 156";
     website="www.spinea.com"
    
  }
  else
  {
     companyName = "Cone Drive Operations, Inc.";
     companyAddress = "240 E. 12th Street, Traverse City, Michigan USA 49684";
     contactInfo = "Tel: 231-946-8410, Sales: 888-994-2663";
     website = "www.conedrive.com";
  }
     tableId= 'specification';
     userInputTable='userInput';
     tableId2='specificationDetails';
     productCode = this.finalData.ConfigurationNo;
     productName = "Series HP";


  this.pdfService.generatePdf(companyName, companyAddress, contactInfo, website, tableId, tableId2,productCode,productName,userInputTable);
}
createCAD1(): void {
  const imgElement = document.getElementById('cadImage') as HTMLImageElement;
  if (imgElement) {
    imgElement.src = '';
  }
  const ClientIP1=this.ipService.getIP();
  // this.ipService.getIPAddress();
  this.ipService.getIPAddress().subscribe(result=>{
    // console.log("Result in Reducer: "+result);
    this.finalData.ClientIP = result;
    // this.getShaftType(this.Size);
  },
  (error) => {
    console.error('Error fetching in gear orientation :', error);
  })
  const date = new Date();
  const size = document.getElementById("2d_CAD") as HTMLInputElement
  var D = document.getElementById("2d_CAD")
  const cadData={
    Website:"HP",
    Guid: uuidv4(),
    Code:this.finalData.ConfigurationNo.toString().trim(),
    asmFormat:this.CADfileFormat.CAD3DFileFormat.toString().trim(),
    dwgFormat:this.CADfileFormat.CAD2DFileFormat.toString().trim(),
    MotorFrame: "",
    FlangType:this.finalData.FlangType,
    ShaftDia:"",
    TimeIn:this.getCurrentFormattedDate(),
    ClientIP:"10.248.24.1"
  };
  this.finalData.cadLocation = cadData.Guid;
    this.cadService.GenerateCADLoadbalancing(cadData);

  }

getCurrentFormattedDate(): string {
  const now = new Date();

  // Helper function to pad single-digit numbers with leading zero
  const dateData = (num: number) => num.toString().padStart(2, '0');

  return `${now.getFullYear()}-${dateData(now.getMonth() + 1)}-${dateData(now.getDate())}T${dateData(now.getHours())}:${dateData(now.getMinutes())}:${dateData(now.getSeconds())}`;
}

  onCAD2DFileChange(event:any){
    const selectedValue = event.target.value;
    this.CADfileFormat.CAD2DFileFormat = selectedValue;
  }
  onCAD3DFileChange(event:any){
    const selectedValue = event.target.value;
    this.CADfileFormat.CAD3DFileFormat = selectedValue;
  }
  createCAD():void{
    debugger;
    const cadGenArea:any = document.getElementById('cadGenerateArea');
    const cadProArea:any = document.getElementById('cadProcessArea');
    const cadShArea:any = document.getElementById('cadShownArea');
    
    if (cadProArea) {
      if (cadProArea.style.display === 'none') {
        cadGenArea.style.display = 'none';
        cadProArea.style.display = 'block';
      } 
    }
    
    this.cadService.showCADImage(this.finalData.cadLocation+"\\"+this.finalData.ConfigurationNo).subscribe({
      next: (response) => {
        debugger;
        const blob = new Blob([response], { type: 'image/jpeg' }); // Assuming the API returns a JPEG image
        const imageUrl = URL.createObjectURL(blob); // Create an object URL for the image
        this.imageUrl = imageUrl;
        if(this.imageUrl){
          debugger;
          const imgElement = document.getElementById('cadImage');
                if (imgElement) {
                  this.renderer.setAttribute(imgElement, 'src', imageUrl);
                  if (cadProArea) {
                    if (cadProArea.style.display === 'block') {
                      cadProArea.style.display = 'none';
                      cadShArea.style.display = 'block';
                    } 
                  }
                }
        }
      },
      error: (error) => {
        console.error('Error downloading image:', error); // Handle errors
      }
    });
  }
  public download3DPDF(){
    debugger;
    this.cadService.downloadCADFiles(this.finalData.cadLocation+"\\"+this.finalData.ConfigurationNo,".pdf",this.finalData.ConfigurationNo)
  }
  public download3DFile(){
    debugger;
    this.cadService.downloadCADFiles(this.finalData.cadLocation+"\\"+this.finalData.ConfigurationNo,".stp",this.finalData.ConfigurationNo)
  }
  public download2DFile(){
    debugger;
    this.cadService.downloadCADFiles(this.finalData.cadLocation+"\\"+this.finalData.ConfigurationNo,".dxf",this.finalData.ConfigurationNo)
  }
  
  sendPDFToAPI(pdfBlob: Blob) {
    debugger;
    const apiUrl = 'https://localhost:7225/api/UserRegistration/sendemail';  // Your C# API URL

    // Create FormData and append the PDF Blob
    const formData = new FormData();
    formData.append('pdf', pdfBlob, 'Quote_'+this.finalData.ConfigurationNo+'.pdf'); // Name the file as 'generated.pdf'

    // Send POST request with FormData to the C# API
    this.http.post(apiUrl, formData).subscribe(response => {
      console.log('PDF sent to server successfully!', response);
    });
  }
  processAndSendPDF() {
    debugger;
     const url = this.router.url.toLowerCase();
  let companyName: string;
  let companyAddress: string;
  let contactInfo: string;
  let website: string;
  const currentUrl = window.location.href.toLowerCase();
    if (currentUrl.includes('spineatools')) {

     companyName = "SPINEA";
     companyAddress="s.r.o., Ku Magašu 702/3, 080 01 Haniska, District of Prešov, Slovakia";
     contactInfo = "Tel: +421 51 77 00 155, Sales: +421 51 77 00 156";
     website="www.spinea.com"
    
  }
  else
  {
     companyName = "Cone Drive Operations, Inc.";
     companyAddress = "240 E. 12th Street, Traverse City, Michigan USA 49684";
     contactInfo = "Tel: 231-946-8410, Sales: 888-994-2663";
     website = "www.conedrive.com";
  }
  const tableId = 'specification';
  const tableId2='specificationDetails';
  const productCode = this.finalData.ConfigurationNo;
  const productName = "Series HP"
   const userInputTable='userInput';
  
  
    const pdfBlob = this.pdfService.hpPdfRequestQuote(companyName, companyAddress, contactInfo, website, tableId, tableId2,productCode,productName,this.quoteUserData, userInputTable);
    this.sendMail(pdfBlob);  // Send it to the API to send the email
    
  }
  public sendMail(pdfBlob: Blob): void {
    // Call the sendPDFToAPI method and handle the result
    this.sendmail.sendPDFToAPI(pdfBlob, this.finalData.ConfigurationNo, this.quoteUserData);
    
}
showRegisterForm(){
  debugger;
  $('#commonRegisterModal').css("display","block");
  $('#exampleModal').css("display","block");
  
}
closeRegisterModal(){
  debugger;
  $('#commonRegisterModal').css("display","none");
}
closePrivacyModal(){
  debugger;
  $('#exampleModal').css("display","none");
  $('#policyCheck').prop('checked', false);
}
PrivacySubmit(){
  $('#exampleModal').css("display","none");
  $('#policyCheck').prop('checked', true);
}
setAnalytics(product:string, clickType:string){
    this.service.setDataAnalytics(product,clickType).subscribe(result=>{
      },
      (error) => {
        console.error('Error Data Analytics :', error);
      })
  }
populateForm(user: any) {

    console.log('=== POPULATE FORM DEBUG ===');
    console.log('Full user object:', JSON.stringify(user, null, 2));
    console.log('Country field value:', user.country);
    console.log('Country field type:', typeof user.country);
    
    // Check for different possible country field names (case-insensitive) and TRIM
    let countryCode = (user.country || user.Country || user.COUNTRY || '').trim();
    console.log('Resolved country code (raw):', countryCode);
    
    // If country is a full name, try to convert to code
    if (countryCode && countryCode.length > 3) {
      const lowerCountry = countryCode.toLowerCase();
      if (this.countryNameToCode[lowerCountry]) {
        countryCode = this.countryNameToCode[lowerCountry];
        console.log('Converted country name to code:', countryCode);
      } else {
        console.warn('Country name not found in mapping:', countryCode);
      }
    }
    
    console.log('Final country code to use:', countryCode);
    setTimeout(() => {

      this.userDetails.get('country')?.setValue(countryCode, { emitEvent: true });
      this.userDetails.get('country')?.updateValueAndValidity();
      // Then patch the rest
      this.userDetails.patchValue({
        fName: (user.firstName || '').trim(),
        lName: (user.lastName || '').trim(),
        company: (user.company || '').trim(),
        city: (user.city || '').trim(),
        state: (user.state || '').trim(),
        email: (user.email || '').trim(),
        phone: (user.contactNumber || '').trim()
      }, { emitEvent: false });
      // Verify the form value after patching
      console.log('Form country value after patch:', this.userDetails.get('country')?.value);
      console.log('All form values:', this.userDetails.value);
      console.log('Form valid:', this.userDetails.valid);
      console.log('Country control errors:', this.userDetails.get('country')?.errors);
      console.log('=== END DEBUG ===');
    }, 100);
  }

  emailNotFound: boolean = false;
  searchByEmail(): void {
    if (!this.searchEmail || !this.searchEmail.trim()) {
      console.warn('No email entered for search');
      return;
    }

    const email = this.searchEmail.trim().toLowerCase();
    console.log('Searching for email:', email);
    console.log('Total profiles to search:', this.userProfiles.length);

    // Log all emails in userProfiles for debugging
    this.userProfiles.forEach((profile, index) => {
      console.log(`Profile ${index}:`, {
        email: profile.email,
        Email: profile.Email,
        allKeys: Object.keys(profile)
      });
    });

    // Search for the email in userProfiles - check both 'email' and 'Email' fields
    const foundProfile = this.userProfiles.find(profile => {
      const profileEmail = (profile.email || profile.Email || '').trim().toLowerCase();
      console.log(`Comparing "${profileEmail}" with "${email}"`);
      return profileEmail === email;
    });

    if (foundProfile) {
      console.log('Profile found for email:', email, foundProfile);
      this.populateForm(foundProfile);
      this.showEmailSearch = false;
      this.emailNotFound = false;
      this.searchEmail = '';
    } else {
      console.log('No profile found for email:', email);
      this.emailNotFound = true;
      this.snackBar.open('Email address not found in our records. Please enter manually or try a different email.', 'Close', {
        duration: 4000,
        panelClass: ['snackbar-error']
      });
      //this.cdr.detectChanges();
    }
  }
  clearEmailSearch(): void {
    this.searchEmail = '';
    this.emailNotFound = false;
  }  
}

